import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';

// services
import * as OplevAltService from '../../../../services/bb-api/oplevalt/dashboard';
import type { RevenueValuesType } from '../../../../services/bb-api/oplevalt/dashboard';

export const RevenueValues: React.FC = () => {
	const [revenueMTD, setRevenueMTD] = useState<RevenueValuesType>({ subRevenue: 0, experienceRevenue: 0 });
	const [revenueYTD, setRevenueYTD] = useState<RevenueValuesType>({ subRevenue: 0, experienceRevenue: 0 });
	const [dates, setDates] = useState({ startOfMonth: new Date().toISOString(), startOfYear: new Date().toISOString(), today: new Date().toISOString() });

	useEffect(() => {
		const calculateDates = () => { 
			const currentDate = new Date();
		
			const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).toISOString();
			const startOfYear = new Date(currentDate.getFullYear(), 0, 1).toISOString();
		
			setDates({ startOfMonth, startOfYear, today: currentDate.toISOString() });
		}

		calculateDates();

		const intervalTime = 60 * 1000 // 60 seconds
		const intervalId = setInterval(calculateDates, intervalTime)
		return () => clearInterval(intervalId)
	}, [])

	useEffect(() => {
		if (dates.startOfMonth === dates.today) return;
		try {
			OplevAltService.revenue(dates.startOfMonth, dates.today, true).then(setRevenueMTD);
			OplevAltService.revenue(dates.startOfYear, dates.today, true).then(setRevenueYTD);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [dates])


	return (
		<StyledContainer className='revenue-values'>
			<div className='wrapper'>
				{/* MÅNED TIL DATO */}
				<div className='number-box-wrapper'>
					<h2>MÅNED TIL DATO</h2>
					<div className='number-box'>
						<div className='sub-exp-box'>
							<div>
								<p className='label'>Abonnement</p>
								<h1>{revenueMTD.subRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
							</div>
							<div>
								<p className='label'>Oplevelser</p>
								<h1>{revenueMTD.experienceRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
							</div>
						</div>
						<div className='total-box'>
							<div>
								<p className='label'>Total</p>
								<h1>{(revenueMTD.subRevenue + revenueMTD.experienceRevenue).toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
							</div>
						</div>
					</div>
				</div>

				{/* ÅR TIL DATO */}
				<div className='number-box-wrapper'>
					<h2>ÅR TIL DATO</h2>
					<div className='number-box'>
						<div className='sub-exp-box'>
							<div>
								<p className='label'>Abonnement</p>
								<h1>{revenueYTD.subRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
							</div>
							<div>
								<p className='label'>Oplevelser</p>
								<h1>{revenueYTD.experienceRevenue.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
							</div>
						</div>
						<div className='total-box'>
							<div>
								<p className='label'>Total</p>
								<h1>{(revenueYTD.subRevenue + revenueYTD.experienceRevenue).toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></h1>
							</div>
						</div>
					</div>
				</div>
			</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;

	.wrapper {
		display: flex;
		flex-direction: row;
		flex: 1;
	}

	.number-box-wrapper {
		flex: 1;
	}
	
	.number-box {
		display: flex;
		flex-direction: column;
		flex: 1;
		margin: 14px;
		padding: 16px;
		border-radius: 12px;
		background-color: #1f2937;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
	}

	.sub-exp-box {
		display: flex;
		flex-direction: row;
	}

	.total-box {
		border-top: 1px solid #9ca3af;
		padding-top: 16px;
		margin-top: 16px;
	}

	.sub-exp-box div, .total-box div { padding: 0 32px; }
	.sub-exp-box div+div { border-left: 1px solid #9ca3af; }

	h1 {
		font-size: 72px;
		line-height: 1em;
		font-weight: bold;
		margin: 24px 0 0 0;
		color: #ffffff;
	}

	h2 {
		font-size: 32px;
		line-height: 1em;
		margin: 14px 62px 0;
		color: #9ca3af;
	}

	.label {
		font-size: 32px;
		line-height: 1em;
		margin: 0;
		color: #9ca3af;
	}

	.currency { 
		color: #9ca3af; 
		font-size: 48px;
	}
`;
